import React from 'react';
import PropTypes from 'prop-types';

export function QuestionOption(props) {
  return (
    <div className='colorSelectOption'>
      <p className='colorSelectOption_label'>{props.optionLabel}</p>
      {props.children}
    </div>
  );
}

QuestionOption.propTypes = {
  /**
   * List of components to be rendered inside option
   */
  children: PropTypes.arrayOf(PropTypes.element),
  /**
   * label for the Option
   */
  optionLabel: PropTypes.string,
};

QuestionOption.defaultProps = {};
